// @flow

import URLSearchParams from '@ungap/url-search-params';
import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type Tenant, getApiBaseUrlByTenantCode } from '@tectonics/commons/tenant';

export async function getPaymentFromApi(hash: string, tenant: Tenant): Promise<IncomingPayment> {
  const path = 'ws/checkout-v2/invoice';
  const baseUrl = getApiBaseUrlByTenantCode(tenant.code);
  const params = new URLSearchParams({ hash });
  const url = `${baseUrl}${path}?${params.toString()}`;
  const response = await fetch(url);

  return parsePaymentFromResponse(response);
}

async function parsePaymentFromResponse(response: Response): Promise<IncomingPayment> {
  const { payment, status, code, error, status_code, status_message } = await response.json();

  if (status !== 'SUCCESS') {
    throw new Error(`getPaymentFromApi - ${code || status_code} ${error || status_message}`);
  }

  return payment;
}
